module.exports = __webpack_public_path__ + "img/gestoBeijo.dd8682f6.png";